module.exports = __webpack_public_path__ + "27b599908c990e706104c3a58d0f030d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/icon-youtube.svg
// module id = 7
// module chunks = 0